import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { applyAssortmentItemsSortOrder } from '../api/applyAssortmentItemsSortOrder'
import { REQUEST_SAVE_ASSORTMENT_ITEMS_SORT_ORDER } from '../constants'

export const requestSaveAssortmentItemsSortOrder = createAsyncThunk(
  REQUEST_SAVE_ASSORTMENT_ITEMS_SORT_ORDER,
  applyAssortmentItemsSortOrder
)
